export { AutoCleanedStrongCache, AutoCleanedWeakCache } from "./caches.js";
export type { CacheSizes } from "./sizes.js";
export { cacheSizes, defaultCacheSizes } from "./sizes.js";
